export const userReportType = ['Total_Registered_Users', 'Active_Inactive_Users', 'User_Growth_Trends', 'User_Demographics', 'Top_Engaged_Users']
export const financialReportType = ['BOOKING', 'COMMISSION', 'REVENUEBREAKDOWN', 'RELEASEPAYMENT']
export const financialReportListTypeFilter = ['BOOKING', 'PAYMENTRECEIVED', 'COMMISSION', 'REVENUEBREAKDOWN', 'REVENUEGROWTH']

export const serviceReportType = ['Total_Requests_Per_Service', 'Average_Resolution_Time']

export const userReportFilterCase = [{ name: '', value: '' }]
